/* RESPONSIBLE TEAM: team-standalone */

import { tracked } from '@glimmer/tracking';
import {
  REQUIRED_ATTRIBUTES,
  TicketField,
  UserField,
} from 'embercom/objects/standalone/data-fields/common';

export class SalesforceDataFields {
  @tracked userFields: UserField[] = [];
  @tracked caseFields: TicketField[] = [];
  @tracked cvdasForRequiredSalesforceCaseFields: {
    intercom_cvda: { id: string };
    salesforce_field_id: string;
  }[] = [];

  constructor(inputs: {
    userFields: UserField[];
    caseFields: TicketField[];
    cvdasForRequiredSalesforceCaseFields: {
      intercom_cvda: { id: string };
      salesforce_field_id: string;
    }[];
  }) {
    this.cvdasForRequiredSalesforceCaseFields = inputs.cvdasForRequiredSalesforceCaseFields || [];
    this.userFields = this.requiredUserFields.concat(inputs.userFields);
    this.caseFields = this.requiredCaseFields.concat(inputs.caseFields);
  }

  private get requiredUserFields(): UserField[] {
    return REQUIRED_ATTRIBUTES.salesforceUserFields.map((field) => {
      return new UserField({
        id: field.platformIdentifier,
        name: this.titleCase(field.platformIdentifier),
        required: true,
        type: 'string',
        is_mappable: field.isMappable,
        intercom_sda: {
          identifier: field.intercomAttribute,
          type: field.intercomFieldType,
        },
        unique: field.unique || false,
        filterable: field.filterable || false,
      });
    });
  }

  get requiredCaseFields(): TicketField[] {
    return REQUIRED_ATTRIBUTES.caseFields.map((field) => {
      return new TicketField({
        id: field,
        name: this.titleCase(field),
        required: true,
        type: 'string',
        intercom_cvda: this.cvdasForRequiredSalesforceCaseFields.find(
          (cvda) => cvda.salesforce_field_id.toLowerCase() === field.toLowerCase(),
        )?.intercom_cvda,
      });
    });
  }

  titleCase(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
